import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import workflowRunGenerationLaunched, {
	type WorkflowRunGenerationLaunchedAction,
} from '@Application/WorkflowRuns/WorkflowRun/Actions/workflowRunGenerationLaunched';
import workflowRunGenerationLaunchFailed, {
	type WorkflowRunGenerationLaunchFailedAction,
} from '@Application/WorkflowRuns/WorkflowRun/Actions/workflowRunGenerationLaunchFailed';
import type LaunchWorkflowRunGeneration from '@Application/WorkflowRuns/WorkflowRun/Commands/LaunchWorkflowRunGeneration';
import type { WorkflowRunPayload } from '@Application/WorkflowRuns/WorkflowRun/Actions/workflowRunFetched';
import { post } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = WorkflowRunGenerationLaunchedAction | WorkflowRunGenerationLaunchFailedAction;

/** `202` with the run, now generating. */
export default (command: LaunchWorkflowRunGeneration) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<WorkflowRunPayload>(
				`${buildSubjectApiPath(command.facilityId, command.subject)}/workflow-runs/${command.runId}/generations`,
				{},
			);

			const action = workflowRunGenerationLaunched(
				payload,
				command.facilityId,
				command.subject.typeKey,
				command.subject.subjectId,
			);
			dispatch(action);
			return action;
		} catch (error) {
			const action = workflowRunGenerationLaunchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
